import React from 'react';
import { salesPageData } from '../data/salesPageData';
const CARDS = [{
  value: '500+',
  label: 'Planos y proyectos'
}, {
  value: '8',
  label: 'Bonos Especiales'
}, {
  value: '7 días',
  label: 'De garantía'
}, {
  value: '∞',
  label: 'Acceso sin vencimiento'
}];
const MARQUEE = ['500+ Proyectos', 'Melamina', 'Industrial', 'Cocinas', 'Placares', 'Escritorios', 'Racks', 'Repisas', 'Organizadores'];
export function SocialProofSection() {
  return <section className="border-y border-[#EFEDE8]/10 bg-[#181512]" aria-label="Datos de la Bóveda" data-id="element-294" data-mp="2d3m1uufn1hqh">
      <div className="mx-auto max-w-content px-4 py-12 md:px-8 md:py-16" data-id="element-295" data-mp="284j8i790szyc">
        <ul className="grid grid-cols-2 gap-3 sm:gap-4 lg:grid-cols-4" data-id="element-296" data-mp="2n1a92jufkhpj">
          {CARDS.map(card => <li key={card.label} className="reveal rounded-xl border border-[#EFEDE8]/10 bg-[#111111] p-5 text-center transition-transform duration-200 hover:-translate-y-1 hover:border-[#D89A3D]/40 sm:p-6" data-id="element-297" data-mp="2hzt9qsrlh3b2">
              <p className="accent-glow font-numeric text-3xl font-bold leading-none text-[#FF7A00] sm:text-4xl" data-id="element-298" data-mp="3tf9inowzoqz3">
                {card.value}
              </p>
              <p className="mt-2 text-[11px] font-semibold uppercase leading-snug tracking-wide text-[#EFEDE8]/65 sm:text-xs" data-id="element-299" data-mp="13du3l6g4dhcu">
                {card.label}
              </p>
            </li>)}
        </ul>

        <p className="mt-6 text-center text-[11px] text-[#EFEDE8]/35" data-id="element-300" data-mp="1cfjso5mj447g">
          {salesPageData.paymentType} · Producto 100% digital
        </p>
      </div>

      <div className="overflow-hidden border-t border-[#EFEDE8]/10 bg-[#111111] py-3" data-id="element-301" data-mp="fmogq7brhot1">
        <ul className="mx-auto flex max-w-content flex-wrap items-center justify-center gap-x-4 gap-y-2 px-4 text-[10px] font-extrabold uppercase tracking-[0.16em] text-[#EFEDE8]/45 sm:text-xs" data-id="element-302" data-mp="ko3z1rmk1h7q">
          {MARQUEE.map((item, i) => <li key={item} className="flex items-center gap-4" data-id="element-303" data-mp="ti0havclm9hv" data-mpi={i}>
              <span data-id="element-304" data-mp="3t35v9rsqohdt">{item}</span>
              {i < MARQUEE.length - 1 && <span className="text-[#FF7A00]" aria-hidden="true" data-id="element-305" data-mp="zd19ucglknn">
                  ·
                </span>}
            </li>)}
        </ul>
      </div>
    </section>;
}